import { Calendar } from "lucide-react";
import { DetailItem } from "@/bizminer/Admin/InsightRequests/_components/DetailItem.tsx";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card.tsx";
import type { BizminerAdminInsightRequestDetail } from "@/types/serializers";

export const TimestampsCard = ({
  insightRequest,
  formatDate,
}: {
  insightRequest: BizminerAdminInsightRequestDetail;
  formatDate: (dateStr: string | null) => string;
}) => (
  <Card>
    <CardHeader>
      <CardTitle className="text-lg flex items-center gap-2">
        <Calendar className="h-5 w-5" />
        Timestamps
      </CardTitle>
    </CardHeader>
    <CardContent>
      <dl className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <DetailItem label="Created">
          {formatDate(insightRequest.created_at)}
        </DetailItem>
        <DetailItem label="Submitted">
          {formatDate(insightRequest.submitted_at)}
        </DetailItem>
        <DetailItem label="Completed">
          {formatDate(insightRequest.completed_at)}
        </DetailItem>
        <DetailItem label="Updated">
          {formatDate(insightRequest.updated_at)}
        </DetailItem>
      </dl>
    </CardContent>
  </Card>
);
